import DocumentAccordion from "@root/modules/DocumentsPage/DocumentAccordion";
import ViewDocument from "@modules/DocumentsPage/ViewDocument";
new DocumentAccordion();
new ViewDocument();
